<template>

    <div class="overlay" :class="{'is-embedded': isEmbedded}" v-if="maintenance || invalidForm">
        <div class="page-lock">
            <div class="page-logo" v-if="!isEmbedded">
                <a class="brand" href="/">
                    <img src="/static/pages/img/logo.png" alt="logo">
                </a>
            </div>
            <div class="page-body">
                <div v-if="maintenance" class="lock-head"> System Maintenance</div>
                <div v-if="invalidForm" class="lock-head"> Ooops! What happened to this page?</div>
                <div class="lock-body maintenance-body">
                    <div class="lock-cont">
                        <div class="lock-item lock-item-full">
                            <p class="text-center" v-html="maintenanceMessage"></p>
                            <img src="/static/layouts/layout2/img/logo-default.png" alt="logo" class="maintenance-logo" v-if="isEmbedded">
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-footer-custom">© {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.</div>
        </div>
    </div>

    <div v-else :class="{'is-embedded': isEmbedded}">
        <div class="page-content">
            <div class="page-header navbar navbar-fixed-top" v-if="!isEmbedded">
                <div class="page-header-inner ">
                    <div class="page-logo" style="width: 133px;"><a href="/" class="">
                        <img src="/static/layouts/layout2/img/logo-default.png" alt="logo" class="logo-default"></a>
                    </div>
                    <div class="page-top">

                    </div>
                </div>
            </div>

            <div class="page-container">
                <div class="container">
                    <div class="row main-row">
                        <div class="col-12">
                            <div class="portlet light">
                                <div v-if="sent" class="sent-message">
                                    <p v-html="sentMessage"></p>
                                    <a :href="fullUrl" class="btn green create-new-button">Create New Referral</a>
                                    <a v-if="this.dataToken" :href="downloadUrl" class="btn default create-new-button">Download Submission</a>
                                </div>
                                <template v-else>
                                    <vue-spinner v-if="loading"></vue-spinner>

                                    <div v-else>
                                        <vue-form-render
                                          ref="formRender"
                                          :schema="currentForm.schema"
                                          :conditions="currentForm.conditions"
                                          :hideValues="currentForm.hideValues"
                                          :calculations="currentForm.calculations"
                                          :validation-conditions="currentForm.extra_validation_rules"
                                          :date-format="'MM/DD/YYYY'"
                                          :user-access-level="1"
                                          :name="'referral-form'"
                                          :referral-destination-accounts="destinationAccounts"
                                        />
                                        <vue-recaptcha v-if="captchaEnabled"
                                                       v-on:verify="verifyCaptcha"
                                                       :sitekey="captchaPublic"></vue-recaptcha>
                                        <span v-show="invalidCaptcha" class="help-block invalid-captcha-label">Invalid captcha</span>
                                        <br/>
                                        <img src="/static/layouts/layout2/img/logo-default.png" alt="logo" class="bottom-logo" v-if="isEmbedded">
                                        <button class="btn green" @click.prevent="submitForm">Submit</button>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <page-footer v-if="!isEmbedded"></page-footer>
    </div>
</template>


<script>
    import Footer from '../components/menu/Footer.vue';
    import {URL, HTTP} from '@/http-common';
    import VueFormRender from "../components/formbuilder/VueFormRender";
    import Spinner from "../components/Spinner";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: 'EditReferralForm',
        components: {
            VueFormRender,
            VueRecaptcha,
            'page-footer': Footer,
            'vue-spinner': Spinner,
        },

        data() {
            return {
                loading: true,
                currentForm: {
                    name: '',
                    schema: [],
                    conditions: [],
                    calculations: [],
                    values: [],
                    hideValues: [],
                    info: [],
                    extra_validation_rules: [],
                },
                urlRegex: new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, 'g'),
                uid: null,
                maintenance: false,
                maintenanceMessage: '',
                captchaPublic: '',
                sent: false,
                sentMessage: '',
                captchaVerified: false,
                captchaVerifyCode: '',
                invalidCaptcha: false,
                destinationAccounts: [],
                isEmbedded: false,
                invalidForm: false,
                fullUrl: '',
                captchaEnabled: true,
                dataToken: null
            }
        },
        beforeMount() {
            $('head').append('<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer><\/script>');
        },

        methods: {
            fetchForm() {
                HTTP.get('forms/get-referral/' + this.uid).then(response => {
                    if (response.data.status === 'success') {
                        this.currentForm.schema = JSON.parse(response.data.data.data);
                        this.currentForm.conditions = JSON.parse(response.data.data.conditionals);
                        this.currentForm.calculations = JSON.parse(response.data.data.calculations);
                        this.currentForm.extra_validation_rules = JSON.parse(response.data.data.extra_validation_rules);
                        this.currentForm.hideValues = JSON.parse(response.data.data.hide_values);
                        this.maintenance = response.data.data.maintenance.maintenance_mode === "on";
                        this.maintenanceMessage = response.data.data.maintenance.maintenance_message;
                        this.captchaPublic = response.data.data.captcha_public;
                        this.destinationAccounts = response.data.data.destination_accounts;
                        this.invalidForm = false;
                        this.captchaEnabled = response.data.data.captcha_enabled;
                    } else {
                        this.invalidForm = true;
                        this.maintenanceMessage = 'The link is either incorrect or no longer valid.';
                    }
                }).catch(error => {
                    this.loading = false;
                    this.invalidForm = true;
                    this.maintenanceMessage = 'The link is either incorrect or no longer valid.';
                }).finally(() => {
                    this.loading = false;
                });

            },
            submitForm() {
                if (this.captchaEnabled && !this.captchaVerified) {
                    this.invalidCaptcha = true;
                    return;
                }
                this.$refs.formRender.submit().then(results => {
                  if (results.isValid) {
                    this.onSubmit(results)
                  }
                })
            },

            onSubmit({fields, files}) {
                this.loading = true;

                let allData = {
                    data: fields,
                    uid: this.uid,
                    captchaVerifyCode: this.captchaVerifyCode
                };

                // Create FormData
                const formData = new FormData();
                formData.append('data', JSON.stringify(allData));
                files.forEach((file, index) => {
                  formData.append(file.field + '-' + index, file.file);
                })

                HTTP.post(`/forms/save-referral`, formData).then(response => {
                    if (response.data.status === 'success') {
                        this.sent = true;

                        this.sentMessage = response.data.data.message = response.data.data.message.replaceAll(this.urlRegex, match =>
                          `<a href="${match}" target="_blank">${match}</a>`
                        )


                        this.dataToken = response.data.data.data_token;

                        localStorage.setItem('casemgr_referral_submission_token', this.dataToken);
                        this.loading = false;
                        return;
                    }
                    this.sent = false;
                    this.loading = false;
                }).catch(err => {
                    this.sent = true;
                    this.loading = false;
                });
            },
            verifyCaptcha(data) {
                this.captchaVerified = true;
                this.invalidCaptcha = false;
                this.captchaVerifyCode = data;
            }
        },

        computed: {
            downloadUrl: () => {
                return URL+'/referrals/download-submission?id='+localStorage.getItem('casemgr_referral_submission_token')
            },
            getCurrentYear:function(){
                const d = new Date();
                let year = d.getFullYear();
                return year
            }
        },


        mounted() {
            this.uid = this.$route.params.id;

            if (this.$route.name === 'Embedded Referral Form') {
                this.isEmbedded = true;
            }

            this.fullUrl = window.location.href;
            this.fetchForm();
        },
    }
</script>

<style scoped lang="scss">
    .portlet {
        margin-top: 30px;
    }

    .overlay {
        background-color: #ffffff;
        min-height: 100vh;
        min-width: 100vw;
        position: absolute;
    }

    .brand img {
        width: 100%;
    }

    .maintenance-body {
        margin-top: 0;
    }

    .sent-message {
        font-size: 1.4em;
        text-align: center;
        padding: 18vh 0;
        p {
            margin-bottom: 60px;
        }
    }

    .lock-cont {
        width: 100%;
    }

    .invalid-captcha-label {
        color: #f00;
    }

    .is-embedded {
        body, html {
            background: #fff;
        }
        .maintenance-logo {
            margin: 2em auto;
            display: block;
        }
        .page-body {
            margin-top: 0;
        }
        .page-lock {
            margin: 20px;
            width: auto;
        }
        .page-content, .page-container, .portlet, .portlet-body, .portlet-main {
            background: #fff;
            margin: 0;
        }

        .portlet, .portlet.light, .portlet-body {
            padding: 0;
            margin: 20px 0;
        }
        .bottom-logo {
            float: right;
        }
        p.c {
            font-size: 10px;
        }
        .main-vueform {
            padding: 0;
            margin: 0;
        }
        .main-row {
            margin: 0;
            padding: 0;
        }
    }
</style>




// WEBPACK FOOTER //
// EditReferralForm.vue?55fa6624